exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.circle-global-modal{overflow:hidden;position:fixed;right:0;width:372px;height:372px;z-index:9999}@media only screen and (min-device-width:320px) and (max-device-width:480px){.circle-global-modal{width:260px;height:260px}.circle-global-modal.right-side{top:177px;right:0;overflow:visible}.circle-global-modal.left-side{bottom:56px;left:0;overflow:visible}.circle-global-modal.bottom-right-side{bottom:0;right:0}.circle-global-modal.all,.circle-global-modal.top-right-side{top:0;right:0;width:100%;overflow:visible}.circle-global-modal.all{height:100%}}@media only screen and (min-device-width:481px){.circle-global-modal{top:76px}}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/CircleGlobalModal/CircleGlobalModal.scss
// module id = 1711
// module chunks = 0